export function maskCharacters(str, mask="*", n=1) {
    return ('' + str).slice(0, -n)
        .replace(/[0-9]/g, mask)
        + ('' + str).slice(-n);
}